import { render, staticRenderFns } from "./Teletags.vue?vue&type=template&id=712573c0"
import script from "./Teletags.vue?vue&type=script&lang=js"
export * from "./Teletags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports